

import { useEffect } from "react";

const AgeChecker = () => {
  useEffect(() => {
    // ✅ Step 1: Check if age already verified
    const alreadyVerified = localStorage.getItem("isAgeVerified") === "true";
    if (alreadyVerified) {
      return;
    }

    // ✅ Step 2: Prevent re-injection
    if (window.AgeCheckerConfig || window.ageCheckerLoaded) {
      return;
    }

    window.ageCheckerLoaded = true;

    const scriptContent = `(function(w,d) {
      var config = {
        //  key: "7bdSVnSkKA2TBJhiMlw3kVdhhrwq7X6B", 
        key: "xpjPIgKtBfwUQO1WzNzOBnRiMKAMUbFP",
        // element: "#checkout-button",
        element: "#fake-age-checker",
        mode: "auto",
        call_events: true,
        debug: true,
        oncreated: function(verification) {
          localStorage.setItem("ageCheckUUID", verification.uuid);
        },
        onstatuschanged: function(status) {
       
          if (status.status === "accepted") {
            localStorage.setItem("isAgeVerified", "true");
            // alert("Age verified! Proceeding with checkout...");
            // Optional: reload page to reflect verification
            // w.location.reload();
          } else if (status.status === "denied") {
            alert("Age verification failed.");
          }
        },
        onclosed: function() {
          console.log("Popup closed");
        }
      };

      w.AgeCheckerConfig = config;

      var h = d.getElementsByTagName("head")[0];
      var a = d.createElement("script");
      a.src = "https://cdn.agechecker.net/static/popup/v1/popup.js";
      a.crossOrigin = "anonymous";
      a.onerror = function() {
        w.location.href = "https://agechecker.net/loaderror";
      };
      h.insertBefore(a, h.firstChild);
    })(window, document);`;

    const script = document.createElement("script");
    script.type = "text/javascript";
    script.innerHTML = scriptContent;

    document.head.appendChild(script);
  }, []);

  return null;
};

export default AgeChecker;
